module.exports = __webpack_public_path__ + "static/media/google.1915f1d9.svg";